import sortBy from "lodash/sortBy";
import {
  BookingFormDetails,
  DetailsPanelType
} from "PFApp/booking/components/details_panel/details_panel.types";
import { useActiveBookingIndex } from "PFApp/booking/components/details_panel/hooks/use_active_booking_index";
import { ReactElement } from "react";
import { useUnmount } from "react-use";

import { DetailsPanelItem } from "./details_panel_item";
import { useDetailsPanelsActions, useOpenedDetailsPanels } from "./hooks";

const checkIsBookingOrBookingFormPanel = (
  type: DetailsPanelType
): type is DetailsPanelType.Booking | DetailsPanelType.BookingForm =>
  [DetailsPanelType.Booking, DetailsPanelType.BookingForm].includes(type);

export const DetailsPanel = (): ReactElement | null => {
  const openPanels = useOpenedDetailsPanels();
  const bookingFormSidePanel = openPanels.find(({ data }) => data.id === DetailsPanelType.BookingForm);

  const { closeAllDetailsPanels } = useDetailsPanelsActions();
  const { activeBookingIndexByType, handleSetActiveBookingIndexId } = useActiveBookingIndex();

  useUnmount(closeAllDetailsPanels);

  if (!openPanels.length) {
    return null;
  }

  const sortedOpenPanels = sortBy(openPanels, "index");

  const { data: bookingFormData, props: bookingFormProps } =
    bookingFormSidePanel?.data.bookingFormDetails ?? {};
  const bookingFormDetails: BookingFormDetails | undefined = bookingFormSidePanel
    ? {
        mode: bookingFormProps?.mode,
        initialBookingId:
          !!bookingFormData && "bookingId" in bookingFormData ? bookingFormData.bookingId : undefined
      }
    : undefined;

  return (
    <>
      {sortedOpenPanels.map((panel, index) => {
        const isLastSidePanel = index === sortedOpenPanels.length - 1;
        const { type } = panel.data;

        return (
          <DetailsPanelItem
            key={panel.key}
            isOnTop={isLastSidePanel}
            panelData={panel}
            bookingFormDetails={bookingFormDetails}
            disableEntranceAnimation={panel.disableEntranceAnimation}
            {...(checkIsBookingOrBookingFormPanel(type)
              ? {
                  activeBookingIndex: activeBookingIndexByType[type],
                  setActiveBookingIndex: handleSetActiveBookingIndexId(type)
                }
              : {})}
          />
        );
      })}
    </>
  );
};
